import { AxiosResponse } from "axios";
import {
  DeletePayload,
  PostPayload,
  PutPayload,
} from "../../../model/http-crud-models";
import { MutateProductTagPayload, ProductTag } from "../model";
import { UpdateSortingMutationPayload } from "../../../model/UpdateSortingData";
import { httpClient, updateSorting } from "../../../service/http";

export const httpProductTags = {
  createProductTag: async ({
    organizationKeyName,
    data,
  }: PostPayload<MutateProductTagPayload>): Promise<string> => {
    const res = await httpClient<{ id: string }>({
      method: "POST",
      url: `/organizations/${organizationKeyName}/shop-product-tags`,
      data,
    });
    return res.id;
  },
  updateProductTag: ({
    organizationKeyName,
    data,
  }: PutPayload<MutateProductTagPayload>): Promise<AxiosResponse> => {
    const { id, ...rest } = data;
    return httpClient<AxiosResponse>({
      method: "PUT",
      url: `/organizations/${organizationKeyName}/shop-product-tags/${id}`,
      data: rest,
    });
  },
  deleteProductTag: ({
    organizationKeyName,
    data,
  }: DeletePayload): Promise<AxiosResponse> => {
    const { id } = data;
    return httpClient<AxiosResponse>({
      method: "DELETE",
      url: `/organizations/${organizationKeyName}/shop-product-tags/${id}/delete`,
    });
  },
  listProductTags: async ({
    organizationKeyName,
  }: {
    organizationKeyName: string;
  }) => {
    const response = await httpClient<{ data: ProductTag[] }>({
      url: `/organizations/${organizationKeyName}/shop-product-tags`,
    });
    return response.data;
  },

  updateProductTagsSorting: async ({
    organizationKeyName,
    data,
  }: UpdateSortingMutationPayload): Promise<string> => {
    return updateSorting({
      organizationKeyName,
      apiRoute: "shop-product-tags",
      data,
    });
  },
};
